import { render, staticRenderFns } from "./EcoleFR.vue?vue&type=template&id=db4b546e&scoped=true"
var script = {}
import style0 from "./EcoleFR.vue?vue&type=style&index=0&id=db4b546e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b546e",
  null
  
)

export default component.exports